import { useEffect, useState } from 'react'

export const usePersistentSearch = (initialSearchParams = {}, storageKey = 'persistentSearch') => {
  const [search, setSearch] = useState(() => {
    if (typeof window === 'undefined') return initialSearchParams
    const stored = localStorage.getItem(storageKey)
    return stored ? JSON.parse(stored) : initialSearchParams
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(storageKey, JSON.stringify(search))
    }
  }, [search, storageKey])

  return [search, setSearch]
}
